(function () {
    'use strict';

    angular.module("imApp").factory("pohCompAddService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 158,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 162,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
